import React, { useState, useEffect } from "react";
import Navbar from "../components/common/Navbar";
import Footer from "../components/common/Footer";
import { useNavigate } from "react-router-dom";
import styles from "./AdminLoginPage.module.css";
import axios from "axios";

// Automatic Domain Switcher
const API_BASE_URL =
  window.location.hostname === "localhost"
    ? "/api"
    : "https://dukamo.dukamocoffee.com/api";

function AdminLoginPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    // --- SECURITY CHECK 1: USERNAME ---
    const validUsernames = ["betty", "hider"];
    if (!validUsernames.includes(username.toLowerCase().trim())) {
      setError("Unknown Username. Access Denied.");
      return;
    }

    setIsLoading(true);

    try {
      // --- SECURITY CHECK 2: PASSWORD (BACKEND) ---
      const res = await axios.post(`${API_BASE_URL}/cms/verify-login`, {
        code: password,
      });

      if (res.data.success) {
        // --- FIX: Save to LocalStorage as 'adminKey' (Matches other pages) ---
        localStorage.setItem("adminKey", password);
        localStorage.setItem("isAdmin", "true");

        // Clear session storage just in case
        sessionStorage.removeItem("hider_admin_key");

        navigate("/admin/dashboard");
      }
    } catch (err) {
      console.error("Login Error:", err);
      setError("Invalid Access Key. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.adminLoginPage}>
      <Navbar />
      <div className={styles.adminLoginContainer}>
        <form className={styles.adminLoginForm} onSubmit={handleLogin}>
          <h2>Dukamo Admin</h2>
          <p className={styles.subHeader}>Management Portal</p>

          {error && <div className={styles.loginError}>{error}</div>}

          <div className={styles.formGroup}>
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter Username"
              required
              autoComplete="off"
            />
          </div>

          <div className={styles.formGroup}>
            <label htmlFor="password">Access Key</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••••••"
              required
            />
          </div>

          <button
            type="submit"
            className={styles.loginBtn}
            disabled={isLoading}
          >
            {isLoading ? "Authenticating..." : "Enter Dashboard"}
          </button>
        </form>
      </div>
      <Footer />
    </div>
  );
}

export default AdminLoginPage;
